"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _regeneratorRuntime = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _createSuper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SignalingClientEventType_1 = require("../signalingclient/SignalingClientEventType");

var SignalingProtocol_js_1 = require("../signalingprotocol/SignalingProtocol.js");

var BaseTask_1 = require("./BaseTask");

var ListenForVolumeIndicatorsTask = /*#__PURE__*/function (_BaseTask_1$default) {
  _inherits(ListenForVolumeIndicatorsTask, _BaseTask_1$default);

  var _super = _createSuper(ListenForVolumeIndicatorsTask);

  function ListenForVolumeIndicatorsTask(context) {
    var _this;

    _classCallCheck(this, ListenForVolumeIndicatorsTask);

    _this = _super.call(this, context.logger);
    _this.context = context;
    _this.taskName = 'ListenForVolumeIndicatorsTask';

    _this.realtimeMuteAndUnmuteHandler = function (muted) {
      _this.context.signalingClient.mute(muted);
    };

    return _this;
  }

  _createClass(ListenForVolumeIndicatorsTask, [{
    key: "run",
    value: function run() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.context.removableObservers.push(this);
                this.context.signalingClient.registerObserver(this);
                this.context.realtimeController.realtimeSubscribeToMuteAndUnmuteLocalAudio(this.realtimeMuteAndUnmuteHandler);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "removeObserver",
    value: function removeObserver() {
      this.context.realtimeController.realtimeUnsubscribeToMuteAndUnmuteLocalAudio(this.realtimeMuteAndUnmuteHandler);
      this.context.signalingClient.removeObserver(this);
    }
  }, {
    key: "handleSignalingClientEvent",
    value: function handleSignalingClientEvent(event) {
      if (event.type !== SignalingClientEventType_1.default.ReceivedSignalFrame) {
        return;
      }

      if (event.message.type === SignalingProtocol_js_1.SdkSignalFrame.Type.AUDIO_STREAM_ID_INFO) {
        // @ts-ignore
        var audioStreamIdInfo = event.message.audioStreamIdInfo;
        this.context.volumeIndicatorAdapter.sendRealtimeUpdatesForAudioStreamIdInfo(audioStreamIdInfo);
      } else if (event.message.type === SignalingProtocol_js_1.SdkSignalFrame.Type.AUDIO_METADATA) {
        // @ts-ignore
        var audioMetadata = event.message.audioMetadata;
        this.context.volumeIndicatorAdapter.sendRealtimeUpdatesForAudioMetadata(audioMetadata);
      }
    }
  }]);

  return ListenForVolumeIndicatorsTask;
}(BaseTask_1.default);

exports.default = ListenForVolumeIndicatorsTask;